import React, { useState, useEffect, useContext } from "react";
import { Link, Redirect, withRouter } from "react-router-dom";
import { Upload, Tooltip, notification, Icon, Drawer, Form, Input, Checkbox, Select, Radio, Modal } from "antd";
import { GlobalContext } from "../../../../app/providers/GlobalState";
import axios from "axios";
import { downloadFile } from "../../../../shared/utils/fileDownloader";

import { noimage } from "../../../../assets";

const confirm = Modal.confirm;
const openNotificationWithIcon = (type, message, description) => {
    notification[type]({
        message: message,
        description: description
    });
};

const DrawerTabela = ({ estado, setEstado, carregar, form, match, setDocs, setModalVisible }) => {
    const globalContext = useContext(GlobalContext);
    const [redirect, setRedirect] = useState(false);
    const [obrigatorio, setObrigatorio] = useState(false);
    const [redirectLink, setRedirectLink] = useState("");

    const { getFieldDecorator } = form;
    const { Option } = Select;
    const Dragger = Upload.Dragger;

    const handleChange = event => {
        const { name, value } = event.target;
        setEstado(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const onClose = () => {
        setEstado({ visible: false });
    };

    const handlerChangeCheck = event => {
        const { name, checked } = event.target;
        setEstado(prev => ({
            ...prev,
            [name]: checked
        }));
    };

    const handlerChangeRadio = event => {
        const { name, value } = event.target;
        setEstado(prev => ({
            ...prev,
            [name]: value,
            fileList: [],
            link: "",
            texto: ""
        }));
    };

    const handlerChangeRadioPartilha = event => {
        const { name, value } = event.target;
        setEstado(prev => ({
            ...prev,
            [name]: value
        }));
    };

    /*const guardarFicheiro = () => {
        form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                setEstado(prev => ({ ...prev, iconLoading: true }));

                const item = new FormData();
                item.append("id_curso", estado.disciplinaId);

                if (estado.tipo === "UPLOAD") {
                    item.append("nome", `${estado.nome}.${estado.fileList[0].name.split(".").pop()}`);
                    item.append("ficheiro", estado.fileList[0]);
                } else if (estado.tipo === "LINK") {
                    item.append("nome", estado.nome);
                    item.append("ficheiro", estado.link);
                    item.append("link", true);
                } else {
                    item.append("nome", estado.nome);
                    item.append("ficheiro", estado.texto);
                    item.append("editor", true);
                }

                item.append("tipoPartilha", estado.tipo_partilha);
                if (estado.tipo_partilha === "PARTILHADO") item.append("todos", estado.todos);
                item.append("participantes", JSON.stringify(estado.participantes));
                item.append("notificar", estado.notificar);
                if (estado.pastaId > 0) item.append("id_pasta", estado.pastaId);

                axios
                    .post("/api/curso-fichs/adicionar-ficheiro", item)
                    .then(() => {
                        openNotificationWithIcon("success", "Sucesso", "Ação efetuada com sucesso!!");
                        carregar(""); // Chama a função para atualizar a lista
                        setEstado(prev => ({
                            ...prev,
                            iconLoading: false,
                            visible: false
                        }));
                    })
                    .catch(error => {
                        openNotificationWithIcon("error", "Erro", error.response?.data || "Erro ao guardar");
                        setEstado(prev => ({ ...prev, iconLoading: false }));
                    });
            }
        });
    };*/

    const alterarFicheiro = () => {
        form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                setEstado(prev => ({ ...prev, iconLoading: true }));

                const item = new FormData();

                item.append("id", estado.documentoId);
                if (estado.tipo === "UPLOAD") {
                    if (estado.fileList.length > 0) {
                        item.append("nome", `${estado.nome}.${estado.fileList[0].name.split(".").pop()}`);
                        item.append("ficheiro", estado.fileList[0]);
                    } else {
                        item.append("nome", `${estado.nome}.${estado.ficheiros[0].split(".").pop()}`);
                    }
                } else if (estado.tipo === "LINK") {
                    item.append("nome", estado.nome);
                    item.append("ficheiro", estado.link);
                    item.append("link", true);
                } else {
                    item.append("nome", estado.nome);
                    item.append("ficheiro", estado.texto);
                    item.append("editor", true);
                }

                item.append("tipoPartilha", estado.tipo_partilha);
                if (estado.tipo_partilha === "PARTILHADO") item.append("todos", estado.todos);
                item.append("participantes", JSON.stringify(estado.participantes));

                axios
                    .put("/api/documentos/alterar", item)
                    .then(() => {
                        openNotificationWithIcon("success", "Sucesso", "Ficheiro alterado!");
                        carregar(""); // Atualiza a lista
                        setEstado(prev => ({
                            ...prev,
                            iconLoading: false,
                            visible: false
                        }));
                    })
                    .catch(error => {
                        openNotificationWithIcon("error", "Erro", error.response?.data || "Erro ao alterar");
                        setEstado(prev => ({ ...prev, iconLoading: false }));
                    });
            }
        });
    };

    const downloadFicheiro = documentoId => {
        axios({
            method: "post",
            url: "/api/documentos/download",
            params: {
                documentoId
            }
        })
            .then(response => {
                const fileUrl = response.data.url;
                const fileName = response.data.nome;

                downloadFile(fileName, fileUrl);
            })
            .catch(error => {
                if (error.response.status === 401) {
                    setRedirect(true);
                    setRedirectLink("/login");
                } else openNotificationWithIcon("error", "Erro", error.response.data);

                setEstado(prev => ({ ...prev, iconLoading: false }));
            });
    };

    const validarFormatoFicheiro = formato => {
        const formatos = [
            "zip",
            "rar",
            "7z",
            "docx",
            "doc",
            "pdf",
            "odf",
            "txt",
            "rtf",
            "xlsx",
            "xls",
            "csv",
            "ods",
            "pptx",
            "ppt",
            "odp",
            "bmp",
            "gif",
            "png",
            "jpeg",
            "jpg"
        ];
        return formatos.includes(formato.toLowerCase());
    };

    const validar = (rule, value, callback) => {
        if (value?.file) {
            const extensao = value.file.name.split(".").pop().toLowerCase();

            if (value.file.size > 26214400) {
                return callback("Limite de 25 MB por upload!");
            }

            if (!validarFormatoFicheiro(extensao) && value.file.status !== "removed") {
                return callback("Ficheiro com formato inválido!");
            }

            if (value.file.status === "removed") {
                return callback("Campo obrigatório");
            }
        }

        callback();
    };

    const props = {
        accept: ".zip, .rar, .7z, .docx, .doc, .pdf, .odf, .txt, .rtf, .xlsx, .xls, .csv, .ods, .pptx, .ppt, .odp, .bmp, .gif, .png, .jpeg, .jpg",
        multiple: false,
        onRemove: file => {
            props.form.resetFields(["ficheiro"]);

            setEstado(prev => {
                const index = prev.fileList.indexOf(file);
                const newFileList = [...prev.fileList];
                newFileList.splice(index, 1);

                return {
                    ...prev,
                    fileList: newFileList
                };
            });
        },
        defaultFileList: estado.fileList,
        beforeUpload: file => {
            setEstado(prev => ({
                ...prev,
                fileList: [file]
            }));

            return false; // impede o upload automático
        },
        fileList: estado.fileList
    };

    const montar_tipo = tipo => {
        if (tipo === "UPLOAD" && estado.ficheiro != "") {
            return (
                <Form.Item label="Ficheiro">
                    <div className="anexos">
                        {getFieldDecorator("ficheiro", {
                            rules: [
                                { validator: validar } // define a função validar no componente
                            ],
                            initialValue: estado.fileList
                        })(
                            <Dragger {...props}>
                                <p className="ant-upload-drag-icon">
                                    <i className="fas fa-upload" />
                                </p>
                                <p className="ant-upload-text">
                                    {estado.documentoId > 0 ? "Substituir anexo" : "Adicionar anexo"}{" "}
                                    <Tooltip title="Formatos válidos: .zip, .rar, .7z, .docx, .doc, .pdf, .odf, .txt, .rtf, .xlsx, .xls, .csv, .ods, .pptx, .ppt, .odp, .bmp, .gif, .png, .jpeg, .jpg">
                                        <Icon type="question-circle-o" />
                                    </Tooltip>
                                </p>
                                <p className="ant-upload-hint">Limite de 25MB por upload</p>
                            </Dragger>
                        )}
                    </div>
                </Form.Item>
            );
        } else if (tipo === "LINK") {
            return (
                <Form.Item label="Link">
                    {getFieldDecorator("link", {
                        rules: [{ required: estado.link === "", message: "Campo obrigatório" }],
                        initialValue: estado.link
                    })(<Input name="link" onChange={handleChange} />)}
                </Form.Item>
            );
        } else {
            return (
                <Form.Item>
                    {getFieldDecorator("texto", {
                        rules: [
                            {
                                required: estado.texto === "",
                                message: "Campo obrigatório"
                            }
                        ],
                        initialValue: estado.texto
                    })(
                        <>
                            <h3 className="titulo-separador">Editor Web</h3>
                            <Link
                                to="#"
                                className="link-principal"
                                style={{ paddingLeft: 0 }}
                                onClick={() => setEstado(prev => ({ ...prev, visibleHTML: true }))}
                            >
                                {estado.texto ? "Editar" : "Adicionar"}
                            </Link>
                        </>
                    )}
                </Form.Item>
            );
        }
    };

    if (redirect) return <Redirect to={redirectLink} />;

    return (
        <>
            <Drawer
                className="drawer-add-cursos drawer-videoconferencias drawer-drive"
                width={720}
                onClose={onClose}
                visible={estado.visible}
                style={{
                    overflow: "auto",
                    height: "calc(100% - 108px)",
                    paddingBottom: "108px"
                }}
                maskClosable={false}
            >
                <div className="bloco-info">
                    <Form className="form-categorias" layout="horizontal">
                        <div className="bloco">
                            <Form.Item label="Nome">
                                {getFieldDecorator("nome", {
                                    rules: [{ required: true, message: "Campo obrigatório" }],
                                    initialValue: estado.nome
                                })(<Input name="nome" onChange={handleChange} />)}
                            </Form.Item>

                            {estado.documentoId === 0 && (
                                <Form.Item className="form-item-checkbox">
                                    <Radio.Group name="tipo" onChange={handlerChangeRadio} value={estado.tipo}>
                                        <Radio value="UPLOAD">Upload ficheiro</Radio>
                                        <Radio value="LINK">Link</Radio>
                                        <Radio value="EDITOR">Editor</Radio>
                                    </Radio.Group>
                                </Form.Item>
                            )}

                            {montar_tipo(estado.tipo)}

                            {estado?.ficheiros?.length > 0 && (
                                <Form.Item>
                                    <h3 className="titulo-separador">Anexos</h3>
                                    <div className="lista-videos">
                                        {estado?.ficheiros?.map((ficheiro, index) => (
                                            <div key={index} className="item-video">
                                                <span className="video-titulo">{ficheiro}</span>
                                                <div className="video-controlos">
                                                    <Link
                                                        to="#"
                                                        title="Visualizar"
                                                        className="botao-icon-detalhe"
                                                        onClick={() => {
                                                            setModalVisible(true);
                                                            setDocs([{ uri: estado.ficheiro }]);
                                                        }}
                                                    >
                                                        <Icon type="eye" />
                                                    </Link>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </Form.Item>
                            )}
                        </div>

                        <div className="bloco">
                            <h3 className="titulo-separador titulo-com-botao">Partilhado</h3>
                            <Form.Item className="form-item-checkbox">
                                <Radio.Group name="tipo_partilha" onChange={handlerChangeRadioPartilha} value={estado.tipo_partilha}>
                                    <Radio value="PESSOAL">
                                        <i className="fas fa-user icon-tipo-partilha pessoal" title="Pessoal"></i>
                                        Pessoal
                                    </Radio>
                                    <Radio value="INSTRUTORES">
                                        <i
                                            className="fas fa-user-friends icon-tipo-partilha partilhado-instrutor"
                                            title="Partilhado com os professores"
                                        ></i>
                                        Com os professores
                                    </Radio>
                                    <Radio value="PARTILHADO">
                                        <i className="fas fa-users icon-tipo-partilha partilhado" title="Partilhado com a turma"></i>
                                        Com a turma
                                    </Radio>
                                </Radio.Group>
                                <span className="nota-info">
                                    {estado.tipo_partilha === "PESSOAL" && "Documento privado"}
                                    {estado.tipo_partilha === "INSTRUTORES" &&
                                        "Documento partilhado com todos os professores e coordenadores do curso"}
                                    {estado.tipo_partilha === "PARTILHADO" && "Documento partilhado com o aluno"}
                                </span>

                                {estado.tipo_partilha === "PARTILHADO" && (
                                    <div className="lista-participantes" style={{ marginLeft: 50 }}>
                                        <Form.Item className="form-item-checkbox">
                                            <Checkbox className="todos" checked={estado.todos} name="todos" onChange={handlerChangeCheck}>
                                                Todos
                                                <Tooltip
                                                    className="info-icon"
                                                    title="Ao selecionar todos, os alunos que indicar serão considerados exceções."
                                                >
                                                    <Icon type="question-circle-o" />
                                                </Tooltip>
                                            </Checkbox>
                                        </Form.Item>

                                        <Form.Item className="form-item-checkbox">
                                            <label className="label-participantes">
                                                {estado.todos ? "Exceto os seguintes" : "Incluídos os seguintes"}
                                                <button
                                                    className="botao-principal"
                                                    onClick={() => setEstado(prev => ({ ...prev, visibleDrawerPesquisar: true }))}
                                                >
                                                    <Icon type="plus" />
                                                </button>
                                            </label>

                                            {estado.participantes.length > 0 ? (
                                                estado.participantes.map((participante, index) => (
                                                    <div key={index} className="participante">
                                                        <div className="info-participante">
                                                            <div className="container-img">
                                                                <img src={participante.foto || noimage} />
                                                            </div>
                                                            <div className="info">
                                                                <span className="nome">{participante.nome}</span>
                                                                <p className="numero">{participante.numero}</p>
                                                            </div>
                                                        </div>
                                                        <div className="opcoes">
                                                            <button
                                                                className="botao-excluir"
                                                                onClick={() =>
                                                                    setEstado(prev => ({
                                                                        ...prev,
                                                                        participantes: prev.participantes.filter(
                                                                            x => x.id !== participante.id
                                                                        )
                                                                    }))
                                                                }
                                                            >
                                                                <Icon type="delete" />
                                                            </button>
                                                        </div>
                                                    </div>
                                                ))
                                            ) : (
                                                <span className="sem-registos">Sem dados</span>
                                            )}
                                        </Form.Item>
                                    </div>
                                )}
                            </Form.Item>
                        </div>

                        <div className="bloco">
                            <Form.Item className="form-item-checkbox">
                                <Checkbox
                                    name="notificar"
                                    checked={estado.notificar}
                                    disabled={estado.tipo_partilha === "PESSOAL"}
                                    onChange={handlerChangeCheck}
                                >
                                    Notificar por e-mail
                                    <Tooltip className="info-icon" title="Notificar os participantes por e-mail">
                                        <Icon type="question-circle-o" />
                                    </Tooltip>
                                </Checkbox>
                            </Form.Item>
                        </div>
                    </Form>
                </div>

                <div className="ant-drawer-footer">
                    <button className="botao-secundario" onClick={onClose} style={{ marginRight: 20, display: "inline-block" }}>
                        Voltar
                    </button>
                    <button className="botao-principal" disabled={estado.iconLoading} onClick={alterarFicheiro}>
                        {estado.iconLoading && <Icon type="loading" />}
                        Salvar
                    </button>
                </div>
            </Drawer>
        </>
    );
};

// const ContextFicheiros = ({ form, match }) => (
//     <GlobalContext.Consumer>{() => <DrawerTabela form={form} match={match} />}</GlobalContext.Consumer>
// );

const DrawerTabelaForm = Form.create({ name: "form-ficheiro" })(DrawerTabela);

export default withRouter(DrawerTabelaForm);
